import { Box, Typography, useTheme } from '@sbv-clients/ui-shared';

const BreadCrumbItem = ({
  label,
  showSeparator,
  isLast,
  color,
}: {
  label: string;
  showSeparator: boolean;
  isLast: boolean;
  color: string;
}) => (
  <Box display="flex" alignItems="center" minWidth={0} overflow="hidden">
    {showSeparator && (
      <Typography
        color={color}
        sx={{
          mx: '4px',
          fontSize: { xs: '14px', md: '16px' },
          display: isLast ? { xs: 'none', sm: 'block' } : 'block',
        }}
      >
        /
      </Typography>
    )}
    <Typography
      fontWeight={isLast ? 600 : 400}
      color={color}
      sx={{
        fontSize: { xs: '14px', md: '16px' },
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
  </Box>
);

const BreadCrumbs = ({
  breadCrumbLabels = [],
}: {
  breadCrumbLabels?: { label: string }[];
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        overflow: 'hidden',
        maxHeight: '2.8em',
        gap: '2px',
        width: '100%',
      }}
    >
      {breadCrumbLabels.map((item, index) => {
        const isLast = index === breadCrumbLabels.length - 1;
        return (
          <Box
            key={index}
            display={{ xs: isLast ? 'flex' : 'none', sm: 'flex' }}
            minWidth={0}
            overflow="hidden"
          >
            <BreadCrumbItem
              label={item.label}
              showSeparator={index > 0}
              isLast={isLast}
              color={theme.background.darkGrey3}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default BreadCrumbs;
